(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@ecomplus/utils"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["@ecomplus/utils", "axios"], factory);
	else if(typeof exports === 'object')
		exports["ecomClient"] = factory(require("@ecomplus/utils"), require("axios"));
	else
		root["ecomClient"] = factory(root["@ecomplus/utils"], root["axios"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__11__, __WEBPACK_EXTERNAL_MODULE__131__) {
return 